import React, { useContext, useEffect, useState } from 'react';

import { AuthContext } from '../authentication/AuthContext';
import { fetchAppConfigs } from './appConfigService';

const DEFAULT_APP_CONFIG_STATE = {
  isLoaded: false,
  assetPublicUrl: '',
  assetPublicFallbackUrl: '',
  assetPrivateUrl: '',
  ENABLE_BUNDLE_PACKBOMB: '',
  ENABLE_SEGMENT: '',
  ENV_NAME: '',
};

export const AppConfigContext = React.createContext(DEFAULT_APP_CONFIG_STATE);

export const AppConfigProvider = ({ children }) => {
  const [state, setState] = useState(DEFAULT_APP_CONFIG_STATE);
  const { admin } = useContext(AuthContext);

  async function fetchData() {
    if (admin) {
      const {
        assetPublicUrl,
        assetPublicFallbackUrl,
        assetPrivateUrl,
        ENABLE_BUNDLE_PACKBOMB,
        ENABLE_SEGMENT,
        ENV_NAME,
      } = await fetchAppConfigs();
      setState({
        isLoaded: true,
        assetPublicUrl,
        assetPublicFallbackUrl,
        assetPrivateUrl,
        ENABLE_BUNDLE_PACKBOMB,
        ENABLE_SEGMENT,
        ENV_NAME,
      });
    }
  }

  useEffect(() => {
    fetchData();
  }, [admin]);

  return (
    <AppConfigContext.Provider value={{ ...state }}>
      {children}
    </AppConfigContext.Provider>
  );
};
